import { ISingleIdParams } from '../types/actionParams';
import { DatabaseAllowedActions } from '../types/DatabaseAllowedActions';
import { Request } from './Request';

export class GetDatabaseActionsRequest extends Request<ISingleIdParams, DatabaseAllowedActions> {
  constructor(id: string) {
    super('getDatabaseActions', { id: id });
  }
}
